<template>
  <div class="xinsheng-warp system-warp">
    <FilterForm
      :formData="filterData"
      :filters="filters"
      @changeDept="changeDept"
      @submit="handleSubmit"
      @reset="handleReset"
    />

    <div class="system-btn user-btn">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleNew"
      >来访登记</el-button
      >

      <el-button
          v-if="buttons.includes('分配按钮')"
          type="primary"
          size="small"
          @click="handleDistribution"
      >分配给</el-button>
    </div>

    <CustomerTable
        ref="tableRef"
      v-if="tableData"
      :selection="true"
      @selection="handleSelectionChange"
      :tableColumn="tableColumn"
      :tableData="tableData"
        @edit="goToEdit"
      @nameDrawer="handleNameDrawer"
      @view="handleViewHtml"
      @deleteHtml="handleDeleteHtml"
    />
    <CustomerPagination
      :total="total"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
    />

    <DistributionDialog
        title="分配给"
        :isShowDialog="isShowDialog1"
        :forms="forms"
        :formData="formData"
        :width="500"
        @submit="handleDistributionSubmit"
        @close="handleClose"
    />

    <CustomerDetail
      width="1200px"
      :isShowDialog="isShowDialog"
      @close="handleClose"
      direction="rtl"
      :userId="userId"
      @next="handleNextCustomer"
      @prev="handlePrevCustomer"
    />

    <RoleDialog
        title="审核"
        :isShowDialog="isShowApproveDialog"
        :forms="approveForms"
        :formData="approveFormData"
        :width="500"
        @submit="handleApproveSubmit"
        @close="handleApproveClose"
    />

  </div>

</template>

<script>
import FilterForm from "@/components/filter";
import { computed, onMounted, reactive, ref } from "vue";
import { tableColumn } from "./index.js";
import CustomerTable from "@/components/table";
import CustomerPagination from "@/components/pagination";
import { useStore } from "vuex";
import { getUserByDept } from "@/api/method/common";
import { getDistributeUsers } from "@/api/method/system";
import { distribute } from "@/api/method/customer";
import CustomerDetail from "@/components/drawer-form/index.vue";
import { reset } from "@/until";
import { ElMessage ,ElButton } from "element-plus";
import {getChannelList} from "../../api/method/channel";
import {postCustomerVisitApprove, deleteCustomerVisitHtml} from "../../api/method/customer-visit";
import RoleDialog from "@/components/dialog-form";
import DistributionDialog from "@/components/dialog-form";

export default {
  name: "ClientVisit",
  components: {
    [ElButton.name]: ElButton,
    FilterForm,
    CustomerTable,
    CustomerPagination,
    CustomerDetail,
    DistributionDialog,
    RoleDialog
  },
  setup() {
    const { dispatch, state } = useStore();
    const filterData = reactive({
      deptId: null,
      userId: null,
      search: null,
      date: null,
    });

    const buttons = ref(localStorage.getItem("buttons").split(","));

    const filters = reactive([
      [
        {
          label: "选择部门",
          type: "select",
          attr: "deptId",
          placeholder: "请选择",
          column: 8,
          option: [],
          labelWidth: "80px",
        },
        {
          label: "选择顾问",
          type: "select",
          attr: "userId",
          placeholder: "请选择",
          column: 8,
          option: [],
          labelWidth: "100px",
        },
        {
          label: "客户",
          type: "input",
          attr: "search",
          placeholder: "搜索客户手机号或姓名",
          suffixIcon: "el-icon-search",
          column: 8,
          labelWidth: "100px",
        },
      ],
      [
        {
          label: '客户来源',
          type: 'select',
          attr: 'source',
          placeholder: '请选择',
          column: 8,
          labelWidth: '80px',
        },
        {
          label: "上门时间",
          type: "dateRange",
          attr: "date",
          column: 8,
          labelWidth: "100px",
          valueFormat: "YYYY-MM-DD",
        },
        {
          type: "button",
          column: 8,
        },
      ],
    ]);

    const pagination = reactive({
      page: 1,
      size: 10,
    });


    const customerIds = ref([]);
    const userId = ref([]);
    const handleSelectionChange = (arr) => {
      customerIds.value = arr.map((item) => item.customerId);
      userId.value = arr.map((item) => item.userId);
    };
    const handleDistribution = async () => {
      if (!customerIds.value.length) {
        ElMessage.warning("请勾选客户后操作");
        return;
      }

      isShowDialog1.value = true;
      const res = await getDistributeUsers();

      forms[0][0].option = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
    };

    /**分配给弹窗 */
    const isShowDialog1 = ref(false);
    const handleClose1 = () => (isShowDialog1.value = false);
    const forms = reactive([
      [
        {
          label: "分配给",
          type: "select",
          attr: "userId",
          placeholder: "请选择销售人员",
          column: 24,
          filterable:true,
          labelWidth: "120px",
          multiple: true,
          option: [],
        },
      ],
    ]);
    const formData = reactive({
      userId: null,
    });

    const approveForms = reactive([
      [
        {
          label: "上门类型",
          type: "select",
          attr: "type",
          placeholder: "请选择上门类型",
          column: 24,
          labelWidth: "120px",
          option: [
            { label: '无效上门', val: "0" },
            { label: '有效上门', val: "1" },
          ],
        },
        {
          label: "备注",
          type: "input",
          inputType:"textarea",
          attr: "content",
          placeholder: "请输入备注",
          column: 24,
          filterable:true,
          labelWidth: "120px"
        },
      ],
    ]);
    const approveFormData = reactive({
      type: null,
      content: null,
      id: null
    });
    const tableRef = ref(null);

    const handleDistributionSubmit = async () => {
      const res = await distribute({
        userId: formData.userId,
        customerIds: customerIds.value,
      });

      if (res.code == 200) {
        ElMessage.success("分配成功！");
        getList();
        handleClose1();
      } else {
        ElMessage.error(res.msg);
      }
      tableRef.value.clearSection();
    };


    const tableData = computed(
      () => state.customerVisit && state.customerVisit.records
    );
    const total = computed(
      () => state.customerVisit && state.customerVisit.total
    );
    const getDepartList = async () => {
      await dispatch("departmentList");
      filters[0][0].option = state.departmentList.map((item) => ({
        label: item.fullName,
        val: item.id,
      }));
    };
    const handleNew = () => {
      window.open("/customer/visit");
    };
    const changeDept = async (id) => {
      const res = await getUserByDept(id);
      filters[0][1].option = res.data.map((item) => ({
        label: item.nickname,
        val: item.id,
      }));
    };

    const getList = () => {
      const { date, ...param } = filterData;

      const startTime = date && date[0];
      const endTime = date && date[1];

      dispatch("customerVisit", {
        ...pagination,
        ...param,
        startTime,
        endTime,
      });
    };

    onMounted(() => {
      getList();
      getDepartList();
      loadChannelList();
    });

    const channelList = ref([]);
    const loadChannelList = async () => {
      const res = await getChannelList();

      channelList.value = res.data.map((item) => ({
        label: item.name,
        val: item.id,
      }));

      filters[1][0].option = channelList.value;
    }

    const currentChange = (page) => {
      pagination.page = page;
      getList();
    };
    const sizeChange = (size) => {
      pagination.size = size;
      getList();
    };

    const handleSubmit = () => getList();
    const handleReset = () => {
      reset(filterData);
      getList();
    };
    const isShowDialog = ref(false);
    const handleClose = () => (isShowDialog.value = false);
    const handleNameDrawer = (row) => {
      isShowDialog.value = true;
      userId.value = row.customerId;
    };
    const handleNextCustomer = () => {
      const index =
        state.customerVisit.records.findIndex(
          (item) => item.customerId == userId.value
        ) + 1;
      if (index == state.customerVisit.records.length) {
        ElMessage.error("已经是最后一个客户了！");
        return;
      }
      userId.value = state.customerVisit.records[index].customerId;
    };
    const handlePrevCustomer = () => {
      const index =
        state.customerVisit.records.findIndex(
          (item) => item.customerId == userId.value
        ) - 1;
      if (index < 0) {
        ElMessage.error("已经是第一个客户了！");
        return;
      }
      userId.value = state.customerVisit.records[index].customerId;
    };

    const isShowApproveDialog = ref(false);
    const goToEdit = async (id) => {
      isShowApproveDialog.value = true;
      approveFormData.id = id;
    };

    const handleApproveSubmit = async () => {
        console.log(approveFormData)
        await postCustomerVisitApprove(approveFormData);
        handleApproveClose();

        getList();
    }
    const handleApproveClose = () => {
          reset(approveFormData);
          isShowApproveDialog.value = false;
    }

    const handleViewHtml = (id) => {
      const record = tableData.value && tableData.value.find((item) => item.id === id);
      if (record && record.html) {
        const newWin = window.open("", "_blank");
        if (newWin) {
          newWin.document.write(record.html);
          newWin.document.close();
        } else {
          ElMessage.warning("请允许浏览器弹窗后重试");
        }
      } else {
        ElMessage.warning("未找到申请表数据");
      }
    };

    const handleDeleteHtml = async (id) => {
      try {
        const res = await deleteCustomerVisitHtml(id);
        if (res.code == 200) {
          ElMessage.success("申请表删除成功！");
          getList();
        } else {
          ElMessage.error(res.msg || "删除失败");
        }
      } catch {
        ElMessage.error("网络错误，请重试");
      }
    };

    return {
      filters,
      filterData,
      tableColumn,
      tableData,
      buttons,
      handleDistributionSubmit,
      handleDistribution,
      handleSelectionChange,
      isShowDialog1,
      handleClose1,
      forms,
      formData,
      total,
      changeDept,
      currentChange,
      sizeChange,
      handleSubmit,
      handleReset,
      handleNew,
      isShowDialog,
      handleClose,
      goToEdit,
      isShowApproveDialog,
      approveFormData,
      approveForms,
      handleApproveSubmit,
      handleApproveClose,
      handleNameDrawer,
      userId,
      handleNextCustomer,
      handlePrevCustomer,
      handleViewHtml,
      handleDeleteHtml,
    };
  },
};
</script>

<style lang="scss" scoped>
.user-btn {
  padding-bottom: 20px;
}
.container {
  display: flex;
  height: auto;
  //   min-height: 100%;
  .left {
    width: 250px;
    background: #f5f6f9;
    margin-right: 24px;
    padding: 20px;
  }
  .right {
    flex: 1;
    background-color: #fff;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.company-block {
  margin-bottom: 20px;
}

.company-block .el-input__inner {
  background: white !important;
}
.depart-tree {
  background: #f5f6f9;
  .el-tree-node__content {
    background: #f5f6f9;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background-color: #406fff;
    color: white;
  }
}
</style>
